import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChartsDashboardComponent } from './components/charts-dashboard/charts-dashboard.component';
import { CardChartComponent } from 'app/charts-dashboard/components/card-chart/card/card-chart.component';
import { ChartsLayoutComponent } from './components/charts-layout/charts-layout.component';
import { ChartsDashboardControlPanelComponent } from './components/charts-dashboard-control-panel/charts-dashboard-control-panel.component';
import { ChartsLayoutMenuComponent } from './components/controls/charts-layout-menu/charts-layout-menu.component';
import { SharedModule } from '@iv/shared/shared.module';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { ChartSelectorComponent } from './components/controls/chart-selector/chart-selector.component';
import {
  HistoricalChartComponent,
  MaturityChartComponent,
  IvxHistoryComponent,
  AddChartDialogComponent,
  CompareSymbolDialogComponent,
  CompareDateDialogComponent,
  CommonChartComponent,
  SpotChartComponent,
  TotalOiChartComponent,
  HistoricalVolatilityChartComponent,
  ImpliedVolatilityChartComponent,
  IvPremiumChartComponent,
  TermStructureRollingChartComponent,
  SkewChartComponent,
  IvDifferenceComponent,
  SingleContractAnalyzerComponent
} from 'app/charts-dashboard/components';
import { DxDateBoxModule } from 'devextreme-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CardChartControlsComponent } from 'app/charts-dashboard/components/card-chart/controls/card-chart-controls.component';
import { CardChartTabsComponent } from './components/card-chart/tabs/card-chart-tabs.component';
import { CardChartActionsComponent } from 'app/charts-dashboard/components/card-chart/actions/card-chart-actions.component';
import { DateTimeSelectorComponent } from './components/controls/date-time-selector/date-time-selector.component';
import { ChartsDashboardStateService } from 'app/charts-dashboard/state/charts-dashboard-state.service';
import { ChartsHttpService } from './services/charts-http.service';
import { ChartsCommonService } from './services/charts-common.service';
import { ChartsDialogsService } from 'app/charts-dashboard/services/charts-dialogs.service';
import {
  TuiButtonModule,
  TuiHintModule,
  TuiTextfieldControllerModule
} from '@taiga-ui/core';
import {
  TuiCheckboxLabeledModule,
  TuiCheckboxModule,
  TuiInputModule
} from '@taiga-ui/kit';

@NgModule({
  declarations: [
    ChartsDashboardComponent,
    CardChartComponent,
    ChartsLayoutComponent,
    ChartsDashboardControlPanelComponent,
    ChartsLayoutMenuComponent,
    HistoricalChartComponent,
    ChartSelectorComponent,
    AddChartDialogComponent,
    CompareSymbolDialogComponent,
    CardChartControlsComponent,
    CardChartTabsComponent,
    CardChartActionsComponent,
    MaturityChartComponent,
    CommonChartComponent,
    CompareDateDialogComponent,
    DateTimeSelectorComponent,
    SpotChartComponent,
    IvxHistoryComponent,
    TotalOiChartComponent,
    HistoricalVolatilityChartComponent,
    ImpliedVolatilityChartComponent,
    IvPremiumChartComponent,
    TermStructureRollingChartComponent,
    SkewChartComponent,
    IvDifferenceComponent,
    SingleContractAnalyzerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    DxDateBoxModule,
    NgxSpinnerModule,
    TuiButtonModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiCheckboxModule,
    TuiHintModule,
    TuiCheckboxLabeledModule
  ],
  exports: [
    ChartsDashboardComponent
  ],
  entryComponents: [
    ChartsDashboardComponent,
    AddChartDialogComponent,
    CompareSymbolDialogComponent,
    CompareDateDialogComponent
  ],
  providers: [
    ChartsHttpService,
    ChartsCommonService,
    ChartsDashboardStateService,
    ChartsDialogsService
  ]
})
export class ChartsDashboardModule {
}
